<template>
  <div>
    <HeaderContent title="Extracharge Report" />

    <ActionContent
      :cta="false"
      :filter-modal="false"
      :show-export="false"
      v-model:start-date="startDate"
      v-model:end-date="endDate"
      v-model:search="search"
      @search-query="handleSearch"
    />

    <StatisticData
      title="Extracharge Statistics"
      :data="statistics"
    />

    <CheckOutDataTable
      :data="reports"
      :header="headers"
      :currentPage="currentPage"
    />

    <!-- <div class="text-end mt-3 fw-bold fs-5 me-3">
      Grand Total : {{ formatIDR(grandTotal) }}
    </div> -->
  </div>
</template>

<script>
import { ref, inject, onMounted, watch } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import CheckOutDataTable from "@/components/DataTable.vue";
import StatisticData from "@/components/StatisticData.vue";
import { formatIDR } from "@/utils/currency";
import { getFormattedDate } from "@/composable/getDateTimeFormatter";
import iconCompleted from "../../../../public/icons/clipboard-check.svg";
import iconOverall from "../../../../public/icons/square-poll-vertical.svg";
import iconItem from "../../../../public/icons/boxes.svg";

export default {
  components: {
    HeaderContent,
    ActionContent,
    CheckOutDataTable,
    StatisticData,
  },

  setup() {
    const repositories = inject("repositories");
    const reportRepository = repositories.report;

    const reports = ref([]);
    const grandTotal = ref(0);
    const currentPage = ref(1);

    const date = new Date();
    const getStartDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-01`;

    const getCurrentDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    const startDate = ref(getStartDate);
    const endDate = ref(getCurrentDate);

    const search = ref("");

    const statistics = ref([
      {
        label: "Total",
        key: "Reservation",
        value: 0,
        color: "success",
        icon: iconCompleted,
      },
      {
        label: "Total",
        key: "Quantity",
        value: 0,
        color: "primary",
        icon: iconItem,
      },
      {
        label: "Total",
        key: "Amount",
        value: 0,
        color: "primary",
        icon: iconOverall,
      },
    ]);

    const headers = ref([
      {
        key: "no",
        label: "No.",
        tdClass: "text-center",
      },
      {
        key: "transaction_date",
        label: "Date",
        formatter: (value) => getFormattedDate(value),
        sortable: true,
        tdClass: "text-center",
      },
      {
        key: "reservation_number",
        label: "No. Reservation",
        sortable: true,
        tdClass: "text-center",
      },
      {
        key: "extracharge_name",
        label: "Item",
        sortable: true,
        tdClass: "text-left",
      },
      {
        key: "price",
        label: "Price",
        sortable: true,
        tdClass: "text-right",
        formatter: (value) => formatIDR(value),
      },
      {
        key: "qty",
        label: "Quantity",
        sortable: true,
        tdClass: "text-center",
      },
      {
        key: "total",
        label: "Total",
        sortable: true,
        formatter: (value) => formatIDR(value),
        tdClass: "text-right",
      },
      {
        key: "guest_name",
        label: "Guest Name",
        sortable: true,
        tdClass: "text-left",
      },
    ]);

    const getAll = async (start = null, end = null, keyword = "") => {
      const params = {};
      if (start) params.start = start;
      if (end) params.end = end;
      if (keyword) params.search = keyword;

      try {
        const res = await reportRepository.getExtraChargeReport(params);

        reports.value = res.data.data || [];
        grandTotal.value = res.data.grand_total || 0;

        // === HITUNG STATISTIK (Pattern Imigration) ===
        const totalQty = reports.value.reduce(
          (sum, item) => sum + Number(item.qty),
          0
        );

        const uniqueReservation = new Set(
          reports.value.map((item) => item.reservation_number)
        );

        const reservationStat = statistics.value.find(
          (s) => s.key === "Reservation"
        );
        const qtyStat = statistics.value.find(
          (s) => s.key === "Quantity"
        );
        const amountStat = statistics.value.find(
          (s) => s.key === "Amount"
        );

        if (reservationStat) reservationStat.value = uniqueReservation.size;
        if (qtyStat) qtyStat.value = totalQty;
        if (amountStat) amountStat.value = formatIDR(grandTotal.value);

      } catch (e) {
        console.error("Extracharge report error:", e.response?.data);
      }
    };

    const handleSearch = () => {
      getAll(startDate.value, endDate.value, search.value);
    };

    const handleExport = () => {
      const query = new URLSearchParams({
        start_date: startDate.value,
        end_date: endDate.value,
      }).toString();

      window.open(`/extracharge-report/print?${query}`, "_blank");
    };


    watch([startDate, endDate], () => {
      getAll(startDate.value, endDate.value, search.value);
    });

    onMounted(() => {
      getAll(startDate.value, endDate.value);
    });

    return {
      reports,
      headers,
      startDate,
      endDate,
      formatIDR,
      currentPage,
      grandTotal,
      handleExport,
      statistics,
      search,
      handleSearch,
    };
  },
};
</script>